import { render, staticRenderFns } from "./TotalCartItems.vue?vue&type=template&id=14024baa&scoped=true&"
import script from "./TotalCartItems.vue?vue&type=script&lang=js&"
export * from "./TotalCartItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14024baa",
  null
  
)

export default component.exports